let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aF0RO")).then(() => parcelRequire('ejuPL'));